/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GetExerciseImageSchema } from '../models/GetExerciseImageSchema';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ExercisesImagesApi {
    /**
     * Patch Exrcise Image Api
     * Patch exercise image.<br>Required permission: edit_exercises
     * @returns GetExerciseImageSchema OK
     * @throws ApiError
     */
    public static exercisesImagesPatchExrciseImageApiPatch({
        exerciseImageId,
    }: {
        exerciseImageId: string,
    }): CancelablePromise<GetExerciseImageSchema> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/exercises-images/{exercise_image_id}/',
            path: {
                'exercise_image_id': exerciseImageId,
            },
        });
    }
}
